export default "__VITE_ASSET__12be5d9a__"